<script setup lang="ts">
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';
    const emit = defineEmits(['change']);

    interface FormSelectOption {
        value: string | number;
        text: string;
        disabled?: boolean;
    }

    const props = withDefaults(
        defineProps<
            FormInputProps & {
                multiple?: boolean;
                withNullOption?: boolean;
                options?: FormSelectOption[];
            }
        >(),
        {
            withNullOption: false,
            multiple: false,
        },
    );

    const inputData: FormInputData = useFormInput(props, { themeKey: 'select' });
</script>

<template>
    <FormElement :input-data="inputData">
        <div class="relative">
            <select
                :id="inputData.inputId.value"
                v-model="inputData.model.value"
                :class="[inputData.className.value, 'cursor-pointer pr-8 md:pr-10']"
                :name="inputData.props.inputName"
                :multiple="multiple"
                :disabled="inputData.props.disabled"
                @change="emit('change', $event)"
            >
                <option
                    v-if="withNullOption"
                    value=""
                >
                    {{ $t('misc.select_placeholder') }}
                </option>
                <slot>
                    <option
                        v-for="option in options"
                        :key="option.value"
                        :value="option.value"
                    >
                        {{ option.text }}
                    </option>
                </slot>
            </select>
            <i class="fa-solid fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none z-10 text-xs" />
        </div>
    </FormElement>
</template>
